import React from 'react';
import Helmet from 'react-helmet';
import Nav from '../components/Nav';
import ogImage from '../assets/img/twojabi-opengraph.png'

import './index.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/theme.css';
import '../assets/css/custom.css';

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[{ name: 'description', content: 'W TwójABI zajmujemy się przystosowywaniem organizacji do RODO, pełnimy obowiązki Inspektora Ochrony Danych Osobowych w firmach jak również świadczymy inne usługi związane z Administracją Bezpieczeństwa Informacji. Pełnimy funkcję ABI dla wielu firm z takich miast jak Racibórz, Rybnik, Krzanowice Katowice, Opole.' },
       { property: 'og:title', content: 'TwójABI | Kancelaria Ekspertów' },
       { property: 'og:description', content: 'TwójABI zajmuje się przystosowywaniem organizacji do RODO, pełni obowiązki Inspektora Ochrony Danych Osobowych w firmach jak również świadczy inne usługi związane z Administracją Bezpieczeństwa Informacji.' },
       { property: 'og:image', content: ogImage }]}
    />
    <Nav />
    <div className="main-container">{children()}</div>
  </div>
);

export default Layout;

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js